import { clientApi } from "@/shared/services/apiClient";
import type {
  SignInRequest,
  SignInResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  MessageResponse,
} from "../types/types";

const JSON_HEADERS = { "Content-Type": "application/json" };

export async function signIn(data: SignInRequest): Promise<SignInResponse> {
  const response = await fetch("/api/auth/sign-in", {
    method: "POST",
    headers: JSON_HEADERS,
    body: JSON.stringify({
      tenant: data.tenant.toLowerCase(),
      email: data.email,
      password: data.password,
      code: data.code,
    }),
    credentials: "include",
  });

  const payload = await response.json().catch(() => ({}));
  return {
    ok: response.ok && payload?.ok !== false,
    code: payload?.code,
    message: payload?.message,
  };
}

export async function forgotPassword(data: ForgotPasswordRequest): Promise<MessageResponse> {
  const headers: Record<string, string> = {};

  if (data.tenant) {
    headers["X-Tenant-Code"] = data.tenant;
  }

  const response = await clientApi.post(
    "/forgot-password",
    { email: data.email },
    { headers }
  );
  return response.data;
}

export async function resetPassword(data: ResetPasswordRequest): Promise<MessageResponse> {
  const headers: Record<string, string> = {};

  if (data.tenant) {
    headers["X-Tenant-Code"] = data.tenant;
  }

  const response = await clientApi.post(
    "/reset-password",
    {
      token: data.token,
      new_password: data.new_password,
      new_password_confirm: data.new_password_confirm,
    },
    { headers }
  );
  return response.data;
}
